import { useTranslation } from 'react-i18next';

export default function JobsPage() {
  const { t } = useTranslation();

  return (
    <div className="page">
      <div className="page-header">
        <h1 className="page-title">
          <i className="fa fa-wrench" /> {t('Jobs', 'Jobs')}
        </h1>
      </div>
      <div className="form-card">
        <div className="empty-state">
          <i className="fa fa-wrench" style={{ fontSize: 48, marginBottom: 12, display: 'block', color: 'var(--mod-job)' }} />
          <p>Jobs module — track repair and service jobs.</p>
          <p className="text-muted">Coming soon</p>
        </div>
      </div>
    </div>
  );
}
